module.exports = __webpack_public_path__ + "img/badge-diamond.da237ad8.png";